import React, { useState } from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { injectIntl } from 'react-intl';

function UserSearchAutocompleteComponent(props) {
  const [ searchString, setSearchString ] = useState( "" );

  const handleOnSearch = (string, results) => {
    setSearchString( string );
  }

  const handleOnSelect = (item) => {
    props.onSelect( item );
    setSearchString( '' );
  }

  const formatResult = (userId) => {
    let formattedUser = '';

    props.data.forEach( item => {
      if (item.id === userId) {
        formattedUser = `${item.first_name}  ${item.last_name} (${item.email})`;
        return;
      }
    } );

    return formattedUser;
  }

  const handleOnBlur = () => {
    setSearchString( "" );
  }

  return (
    <div
      className={`search-autocomplete-container ${props.errorClass ? props.errorClass : ''}`}
      onBlur={handleOnBlur}>
      <div className="content-autocomplete">
        <ReactSearchAutocomplete
          items={props.data}
          fuseOptions={{ keys: [ "first_name", "last_name", "email" ] }}
          resultStringKeyName="id"
          onSearch={handleOnSearch}
          onSelect={handleOnSelect}
          inputSearchString={searchString}
          showIcon={false}
          autoFocus
          formatResult={formatResult}
          placeholder={props.intl.formatMessage( { id: "pages.clients.add_btn" } )}
          styling={{ zIndex: 1, borderRadius: "5px", boxShadow: "none" }}
          maxResults={10000}
          id="usersNotInGroup"
        />
      </div>
    </div>
  )
}

const UserSearchAutocomplete = injectIntl( UserSearchAutocompleteComponent )
export { UserSearchAutocomplete, UserSearchAutocompleteComponent }
